// extracted by mini-css-extract-plugin
export var cardIcon = "_8u-5";
export var cardIconUnframed = "_8u-9";
export var checkboxCard = "_8u-0";
export var checkboxCardSelected = "_8u-4";
export var disabled = "_8u-2";
export var interactive = "_8u-1";
export var outerBorder = "_8u-3";
export var spacerMedium = "_8u-8";
export var spacerSmall = "_8u-7";
export var spacerXsmall = "_8u-6";